import React from 'react';
import '../css/Footer.css';

import Headphones from '../assets/Headphones.png';

/*
//REMOVED SOCIAL LINKS
import Linkedin from '../assets/Linkedin.png';
import Twitter from '../assets/Twitter.png';
import Youtube from '../assets/Youtube.png';
*/

import {Row, Col} from 'react-bootstrap';
import '../css/bootstrap-theme.min.css';
import '../css/bootstrap.min.css';
import Localize from "./Localize";

class Footer extends Localize{

    displayContent(id) {
        var contentList = this.props.Content;
        var localizedContent;

        contentList.forEach(function (content) {
            if (content.id === id) {
                localizedContent = this.applySettings(content);
            }
        }, this);

        return localizedContent;
    }

    render(){

        // var privacy_url = "";
        // var terms_url = "";
        // var cookies_url = "";

        return(
            <div className = "footer-content">
                <Row className = "footer-service">
                    <Col xs={12} className="strong-text">
                        <img src ={Headphones} alt="headphones"/> {this.displayContent('customerServiceContactInfoLabel')}
                    </Col>
                    <Col xs={12} className="strong-text">
                        {this.displayContent('customerServiceContactInfo')}
                    </Col>
                </Row>

                <Row className = "footer-social" >
                    <Col xs={12} md={4}></Col>
                    <Col xs={12} md={4}></Col>
                    <Col xs={12} md={4}>
                        <a className="link-text" href={this.displayContent('dechraSiteUrl')}>
                            {this.displayContent('dechraSiteUrlText')}
                        </a>
                    </Col>
                </Row>
                {/*<div className = "footer-legal">*/}
                    {/*<a className ="legal-text" href={privacy_url} >Privacy Policy </a>*/}
                    {/*<a className ="legal-text" href={terms_url}>Terms of Use </a>*/}
                    {/*<a className ="legal-text" href={cookies_url}>Cookies</a>*/}
                {/*</div>*/}
            </div>

        )

    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.js